// API models
// API response
export type ApiResponse = Record<string, any>;

export interface LoginResponse extends ApiResponse {
  id: number;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  token: string;
  expires_on: number;
  expires_in: number;
  refreshToken: string;
  refresh_token_expires_on: number;
  refresh_token_expires_in: number;
  roles: string[];
  languageCode: string;
  parentPartyName: string;
  parentPartyDibCode: string;
  parentPartyId: number;
  useMfa: boolean;
  registeredForMfa: boolean;
  mfaQRCode: string;
}

export interface UpdatePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

// LocalStorage models
export class LoginStorageModel {
  public modelGuid = 'token';
  id: number = 0;
  username: string = '';
  firstName: string = '';
  lastName: string = '';
  token: string = '';
  expires_on: number = 0;
  expires_in: number = 0;
  refreshToken: string = '';
  refresh_token_expires_on: number = 0;
  refresh_token_expires_in: number = 0;
  roles: string[] = [];
  languageCode: string = '';
  errorMessage: string = '';
  daccaToken: string = '';
  parentPartyName: string = '';
  parentPartyDibCode: string = '';
  parentPartyId: number = 0;
  useMfa: boolean = false;
  registeredForMfa: boolean = false;
  mfaQRCode: string = '';
  isSilent: boolean = false;
}

export class LoginOktaStorageModel {
  oktaToken: string = '';
  oktaRefreshToken: string = '';
  oktaTokenExpiresAt: number = 0; 
}
